import { render, staticRenderFns } from "./hosting-cron-jobs-illustration.vue?vue&type=template&id=2a6a81a2"
import script from "./hosting-cron-jobs-illustration.vue?vue&type=script&lang=js"
export * from "./hosting-cron-jobs-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports